import {
  CUSTOMER_LIST_PAGE_REQUEST,
  CUSTOMER_LIST_SET_CUSTOMERS,
  CUSTOMER_LIST_CUSTOMERS_REQUEST,
  CUSTOMER_LIST_SET_CUSTOMER_DETAIL,
  CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST,
  CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL,
  CUSTOMER_LIST_RECEIPT_REQUEST,
  CUSTOMER_LIST_SET_RECEIPT,
  CUSTOMER_LIST_SET_CURRENT_PAGE,
  CUSTOMER_LIST_SET_TOTAL_PAGE,
  CUSTOMER_LIST_SET_KEYWORD,
  CUSTOMER_LIST_SET_SUMMARY,
  CUSTOMER_LIST_SET_TYPE,
  CUSTOMERS_DOWNLOAD_TEMPLATE,
  CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL,
  CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL,
  CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY,
  CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST,
  CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST,
  CUSTOMER_LIST_SET_REDEMPTION_HISTORIES,
  CUSTOMER_LIST_SET_POINT_ACTIVITIES,
  CUSTOMER_LIST_SET_HAS_LOYALTY,
  CUSTOMER_LIST_EXPORT
} from './constants'

export function pageRequest () {
  return {type: CUSTOMER_LIST_PAGE_REQUEST, payload: {}}
}

/******************************************************************************************
 * Customer List
 ******************************************************************************************/

export function setCustomers (customers) {
  return {type: CUSTOMER_LIST_SET_CUSTOMERS, payload: {customers}}
}

/**
 *
 * @param {object} query. must contain key 'page'
 * @param {Array} previousCustomers We need it to append to the pagination
 * @return {{type, payload: {query: *, previousCustomers: *}}}
 */
export function customersRequest (query, previousCustomers) {
  return {type: CUSTOMER_LIST_CUSTOMERS_REQUEST, payload: {query, previousCustomers}}
}

export function setCurrentPage (currentPage) {
  return {type: CUSTOMER_LIST_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function setTotalPage (totalPage) {
  return {type: CUSTOMER_LIST_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function setKeyword (keyword) {
  return {type: CUSTOMER_LIST_SET_KEYWORD, payload: {keyword}}
}

export function setType (type) {
  return {type: CUSTOMER_LIST_SET_TYPE, payload: {type}}
}

export function setSummary (summary) {
  return {type: CUSTOMER_LIST_SET_SUMMARY, payload: {summary}}
}

export function setHasLoyalty (hasLoyalty) {
  return {type: CUSTOMER_LIST_SET_HAS_LOYALTY, payload: {hasLoyalty}}
}
/******************************************************************************************
 * End Customer List
 ******************************************************************************************/

/******************************************************************************************
 * Customer Details
 ******************************************************************************************/

export function customerDetailRequest (customer, query) {
  return {type: CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST, payload: {customer, query}}
}

export function closeCustomerDetail () {
  return {type: CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL, payload: {}}
}

export function setCustomerDetail (customer) {
  return {type: CUSTOMER_LIST_SET_CUSTOMER_DETAIL, payload: {customer}}
}

export function receiptCustomerRequest (payment, customer) {
  return {type: CUSTOMER_LIST_RECEIPT_REQUEST, payload: {payment, customer}}
}

export function setReceiptCustomer (receiptData) {
  return {type: CUSTOMER_LIST_SET_RECEIPT, payload: {receiptData}}
}

/******************************************************************************************
 * End Customer Details
 ******************************************************************************************/

export function downloadCustomerTemplate (filename) {
  return {type: CUSTOMERS_DOWNLOAD_TEMPLATE, payload: {filename}}
}

export function customerExportRequest (fileName, hasLoyalty = false) {
  return {type: CUSTOMER_LIST_EXPORT, payload: {fileName, hasLoyalty}}
}

export function showImportingModeModal () {
  return {type: CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL, payload: {}}
}
export function hideImportingModeModal () {
  return {type: CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL, payload: {}}
}

export function changeModalVisibility (modalVisibility) {
  return {type: CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY, payload: {modalVisibility}}
}

export function setRedemptionHistories (redemptionHistories) {
  return {type: CUSTOMER_LIST_SET_REDEMPTION_HISTORIES, payload: {redemptionHistories}}
}

export function customerRedemptionHistoriesRequest (query) {
  return {type: CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST, payload: {query}}
}

export function setPointActivities (pointActivities) {
  return {type: CUSTOMER_LIST_SET_POINT_ACTIVITIES, payload: {pointActivities}}
}

export function customerPointActivitiesRequest (query) {
  return {type: CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST, payload: {query}}
}



// WEBPACK FOOTER //
// ./app/actions/customers/list/list.js